import React from 'react';
import { Button } from "../../../components/tailwind/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "../../../components/tailwind/dropdown-menu";
import { MoreHorizontal, Calendar, XCircle, Eye } from "lucide-react";

export const CampaignActions = ({ campaign, onReschedule, onCancel, onView }) => {
  const isScheduled = campaign.status?.toLowerCase() === 'scheduled';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8 hover:bg-slate-100 dark:hover:bg-slate-800">
          <MoreHorizontal className="h-4 w-4 text-slate-400" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={() => onView?.(campaign)} className="gap-2 cursor-pointer">
          <Eye className="h-4 w-4" />
          View Details
        </DropdownMenuItem>
        {isScheduled && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onReschedule?.(campaign)} className="gap-2 cursor-pointer">
              <Calendar className="h-4 w-4" />
              Reschedule
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => onCancel?.(campaign)}
              className="gap-2 cursor-pointer text-red-600 focus:text-red-600 dark:text-red-400"
            >
              <XCircle className="h-4 w-4" />
              Cancel Campaign
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
